// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__18hkg","selected":"Chip_selected__1Jjhi"};